import { FC } from "react";
import style from "./TeamAndSpaceCard.module.scss";
import Typhography from "../../../shared/Typhography/Typhography";
import { DotsThreeVerticalIcon, PencilSimpleIcon, UsersThreeIcon } from "@phosphor-icons/react";
import { ISpace } from "../../../models/Space";
import { GenderIcon, TypeSpaceIcon } from "../../../shared/Icons/Icons";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { Link } from "react-router-dom";
import { Button, Menu, Portal } from "@chakra-ui/react";
import { SPACE_GENDERS } from "../../../enums/Space";

const GENDER_LABELS: Record<SPACE_GENDERS, string> = {
  [SPACE_GENDERS.MALE]: "Maschile",
  [SPACE_GENDERS.FEMALE]: "Femminile",
  [SPACE_GENDERS.MIXED]: "Misto",
};

export const TeamAndSpaceCard: FC<{
  data: ISpace;
  onClickEditButton: (record: ISpace) => void;
}> = ({ data, onClickEditButton }) => {
  const { getRoute } = useCustomNavigate();

  // BUG-AUDIT-MEDIUM cards-anchor: usa <Link> per a11y/SEO/middle-click
  // (era <div onClick> non semantic, no proper anchor)
  return (
    <Link
      to={getRoute("DIRECTOR_SPACE_ID", data._id)}
      className={style.container}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <div className={style.topRow}>
        <div className={style.nameRow}>
          <div className={style.iconWrapper}>
            <TypeSpaceIcon type={data.type} size={18} />
          </div>
          <Typhography size="bold-14" className={style.name}>{data.name}</Typhography>
          {data.gender && (
            <div className={style.chipContainer}>
              <GenderIcon type={data.gender} size={12} />
              <Typhography type="span" size="regular-12">
                {GENDER_LABELS[data.gender] ?? data.gender}
              </Typhography>
            </div>
          )}
        </div>

        <Menu.Root>
          <Menu.Trigger>
            <Button
              onClick={(e) => e.stopPropagation()}
              className={style.menuButtonMeatBalls}
              as={DotsThreeVerticalIcon}
            />
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content className="ps-2 pe-2">
                <Menu.Item
                  value="edit"
                  className={`menu__item text-medium-14`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onClickEditButton(data);
                  }}
                >
                  <PencilSimpleIcon />
                  Modifica area
                </Menu.Item>
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      </div>

      <div className={style.footer}>
        <UsersThreeIcon size={14} className={style.teamsBadge} />
        <Typhography size="regular-12" className="color-text-2">
          {data.teams?.length ?? 0} {data.teams?.length === 1 ? "squadra" : "squadre"}
        </Typhography>
      </div>
    </Link>
  );
};

export default TeamAndSpaceCard;
